<template>
	<div class="scrollable only-y" v-loading="loadingProduct" element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="page-header card-base card-shadow--medium">
			<h2 class="no-m white-text"><i class="mdi mdi-basket widget-icon accent-text fs-30"></i> {{ product.productName }}</h2>
		</div>
		<el-card class="page-header card-shadow--medium" style="display: none;">
            <el-card class="m-10">
                <el-form ref="form" label-width="240px" label-position="left">
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Created At">
                            <el-tag type="success" v-model="product.createdAt" disabled>
                                <template>
                                    {{product.createdAt}}
                                </template>
                            </el-tag>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!hidden" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Name">
                            <el-input v-model="product.productName" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="hidden" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Name" >
                            <template>
                                <el-select @change="handleChangeProductName" v-model="product.productName" disabled placeholder="Select">
                                    <el-option
                                    v-for="item in nameOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!hidden" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Price">
                            <el-input v-model="product.price" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item label="Product Type" style="font-weight: bold">
                            <template>
                                <el-select v-model="product.type" placeholder="Select" disabled>
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="product.type=='notification_caping_plafon' && !hidden" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Monthly Free Count">
                            <el-input v-model="product.monthly_free_count" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!hidden" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Template HSM">
                            <!-- <div style="heigt: 100px; overflow-y: scroll; border: 1px solid silver;"> -->
                            <div v-for="a in product.whitelistHsm" :key="a" :value="a">
                                <span>{{ a }} 
                                    <!-- <el-button v-if="disabled==1" type="text" @click="deleteWhitelistHsm(a)" style="color: red"><i class="mdi mdi-close" /></el-button> -->
                                </span>
                            </div>
                            <div>
                                <el-form-item v-if="disabled==1">
                                    <template>
                                        <el-select @change="handleChangeProductType" v-model="product.whitelistHsm" multiple placeholder="Select" size="mini">
                                            <el-option
                                            v-for="item in hsm"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.name">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-form-item>
                            </div>
                            <!-- </div> -->
                        </el-form-item>
                        <!-- <el-form-item label="Template HSM" style="font-weight: bold">
                            <template>
                                <el-select v-model="product.type" placeholder="Select" :disabled="disabled == 0">
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-form-item> -->
                    </el-col>
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Description">
                            <el-input rows="6" v-model="product.description" type="textarea" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!hidden" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Min. Price">
                            <el-input v-model="product.minPrice" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product SKU">
                            <el-input v-model="product.productSKU" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Alias Name">
                            <el-input v-model="product.aliasName" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!hidden" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Allowed User">
                            <el-input v-model="product.allowedUser" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col v-if="hidden" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item  style="font-weight: bold" label="Allowed Prefix">
                            <template>
                                <el-select @change="handleChangePrefix" multiple v-model="product.allowedPrefix" disabled filterable placeholder="Select Prefix">
                                    <el-option
                                    v-for="(item) in countries" :key="item.countryCode"
                                    :label="item.countryName"
                                    :value="'+'+item.prefixCode">
                                    <div>
                                        <span style="margin-right: 5px;"><country-flag :country='`${item.countryCode.toLowerCase()}`' size='small'/></span>
                                        <span style="font-size: 12px">{{ item.countryName + ` (+${item.prefixCode})` }}</span>
                                    </div>
                                    </el-option>
                                </el-select>
                            </template>
                        </el-form-item>
                    </el-col> -->
                    <!-- <el-col v-if="hidden && discount" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item  style="font-weight: bold" label="Discount :">
                        <span v-for="(obj) in product.prefix" :key="obj.code_prefix">
                        <el-form v-if="obj.discount" label-width="50px" :model="obj.discount">
                            <el-form-item label="CBP">
                                <el-row>
                                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                        <el-select v-model="obj.discount.type" :disabled="disabled == 0" placeholder="Select Type">
                                            <el-option
                                            v-for="(it,i) in discountType"
                                            :key="i"
                                            :label="it.label"
                                            :value="it.value">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                        <el-input :disabled="disabled == 0"  @keypress.native="numberOnly" @paste.native="paste($event, index, 'cbp_disc')" v-model="obj.discount.cbp"></el-input>
                                    </el-col>
                                    <el-col style="text-align: center;" :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
                                        <span>{{totalAfterDisc(obj.discount.type, obj.price.cbp,obj.discount.cbp)}}</span>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item label="UI">
                                <el-row>
                                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                        <el-select :disabled="disabled == 0" v-model="obj.discount.type" placeholder="Select Type">
                                            <el-option
                                            v-for="(it,i) in discountType"
                                            :key="i"
                                            :label="it.label"
                                            :value="it.value">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                        <el-input :disabled="disabled == 0"  @keypress.native="numberOnly" @paste.native="paste($event, index, 'ui_disc')" v-model="obj.discount.ui"></el-input>
                                    </el-col>
                                    <el-col style="text-align: center;" :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
                                        <span>{{totalAfterDisc(obj.discount.type, obj.price.ui,obj.discount.ui)}}</span>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item label="BI">
                                <el-row>
                                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                        <el-select :disabled="disabled == 0" v-model="obj.discount.type" placeholder="Select Type">
                                            <el-option
                                            v-for="(it,i) in discountType"
                                            :key="i"
                                            :label="it.label"
                                            :value="it.value">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                        <el-input :disabled="disabled == 0"  @keypress.native="numberOnly" @paste.native="paste($event, index, 'bi_disc')" v-model="obj.discount.bi"></el-input>
                                    </el-col>
                                    <el-col style="text-align: center;" :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
                                        <span>{{totalAfterDisc(obj.discount.type, obj.price.bi,obj.discount.bi)}}</span>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-form>
                        </span>
                    </el-form-item>
                    </el-col> -->
                    <el-col v-if="!hidden && product.productName != 'Omnichannel'" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Count">
                            <el-input v-model="product.count" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!hidden && product.productName == 'Omnichannel'" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Count">
                            <el-input v-model="product.max_account" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="hidden && product.type != '' && product.productName == 'Whatsapp Conversation'" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item v-if="disabled == 0" style="font-weight: bold" label="National Set Prefix Limit">
                            <el-row>
                                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                    <span>CBP Limit per Month</span>
                                    <el-input disabled @keypress.native="numberOnly"  @paste.native="paste($event, index, 'cbp')" size="small" placeholder="Leave empty for '0'" v-model="product.monthly_free_count"></el-input>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                    <span>UI Limit per Month</span>
                                    <el-input disabled @keypress.native="numberOnly"  @paste.native="paste($event, index, 'ui')" size="small" placeholder="Leave empty for 'MAX'" v-model="product.monthly_free_count_ui"></el-input>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                    <span>BI Limit per Month</span>
                                    <el-input disabled @keypress.native="numberOnly"  @paste.native="paste($event, index, 'bi')" size="small" placeholder="Leave empty for 'MAX'" v-model="product.monthly_free_count_bi"></el-input>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item v-else style="font-weight: bold" label="National Set Prefix Limit">
                            <el-row>
                                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                    <span>CBP Limit per Month</span>
                                    <el-input :disabled="product.type == 'notification_caping_plafon' ? false:true" @keypress.native="numberOnly"  @paste.native="paste($event, index, 'cbp')" size="small" placeholder="Leave empty for '0'" v-model="product.monthly_free_count"></el-input>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                    <span>UI Limit per Month</span>
                                    <el-input :disabled="product.type == 'notification_caping_plafon' ? false:true" @keypress.native="numberOnly"  @paste.native="paste($event, index, 'ui')" size="small" placeholder="Leave empty for 'MAX'" v-model="product.monthly_free_count_ui"></el-input>
                                </el-col>
                                <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                    <span>BI Limit per Month</span>
                                    <el-input :disabled="product.type == 'notification_caping_plafon' ? false:true" @keypress.native="numberOnly"  @paste.native="paste($event, index, 'bi')" size="small" placeholder="Leave empty for 'MAX'" v-model="product.monthly_free_count_bi"></el-input>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="hidden && product.type != '' && product.productName == 'Whatsapp Conversation'" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item v-if="disabled == 0" style="font-weight: bold" label="International Set Prefix Limit" >
                            <el-row>
                                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                    <span>CBP Limit per Month</span>
                                    <el-input disabled @keypress.native="numberOnly"  @paste.native="paste($event, index, 'intern')" size="small" placeholder="Leave empty for '0'" v-model="product.monthly_free_count_international"></el-input>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item v-else style="font-weight: bold" label="International Set Prefix Limit" >
                            <el-row>
                                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                    <span>CBP Limit per Month</span>
                                    <el-input :disabled="product.type != 'notification_caping_plafon' ? true:false" @keypress.native="numberOnly"  @paste.native="paste($event, index, 'intern')" size="small" placeholder="Leave empty for '0'" v-model="product.monthly_free_count_international"></el-input>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col v-if="hidden && product.type == 'notification_caping_plafon'" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Hybrid Type">
                                <el-radio-group :disabled="disabled == 0" v-model="product.hybrid_type">
                                    <el-radio :label="1">Bundle Quota</el-radio>
                                    <el-radio :label="2">Plafon Quota</el-radio>
                                </el-radio-group>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Plan">
                            <el-input v-model="product.plan" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="hidden" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Monthly Fee (Subscribe Fee)">
                            <el-input v-model="product.minPrice" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="hidden" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <!-- <el-form-item style="font-weight: bold" label="Product Service :">
                            <el-form :model="product.product_service">
                                <el-form-item label="Service Type">
                                    <el-input disabled v-model="product.product_service.type"></el-input>
                                </el-form-item>
                                <div><p><span>Note: </span>Service Fee x Usage(CBP,BI,UI)</p></div>
                                <el-form-item label="Service Fee">
                                        <el-input  @keypress.native="numberOnly" @paste.native="paste($event, index, 'service')" v-model="product.product_service.fee" :disabled="disabled == 0" maxlength="2"></el-input>
                                </el-form-item>
                            </el-form>
                        </el-form-item> -->
                        <el-form-item v-if="product.product_service && product.product_service.type == 'percentage'" style="font-weight: bold" label="Service Fee (%)">
                            <el-input :disabled="disabled == 0" @keypress.native="numberOnly" @paste.native="paste($event, index, 'service')" v-model="product.product_service.fee" maxlength="2"></el-input>
                        </el-form-item>
                        <el-form-item v-if="product.product_service && product.product_service.type == 'currency'" style="font-weight: bold" label="Service Fee (Currency)">
                            <el-input :disabled="disabled == 0" @keypress.native="numberOnly" @paste.native="paste($event, index, 'service')" v-model="product.product_service.fee" maxlength="2"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="PPN (%)">
                            <el-row>
                                <el-col :span="20">
                                    <el-input v-model="product.tax" :disabled="disabled == 0"></el-input>
                                </el-col >
                                <el-col :span="4">
                                <el-button class="ml-10" type="info" size="medium" @click="synchronize('tax')" :disabled="disabled != 0" :loading="loadingSync">
                                    <i class="mdi mdi-sync"></i> Sync
                                </el-button>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col v-if="hidden" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item label="Reff Note">
                            <el-input :disabled="disabled == 0" type="textarea" :rows="4" v-model="product.reff_note" placeholder="Insert note for updated product (Optional)" class="mt-10"></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p" v-if="product.type.indexOf('tier') != -1 && !hidden">
                        <el-form-item style="font-weight: bold" label="Tier Pricing">
                            <el-row style="margin-bottom: 10px;">
                                <el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px"><span>From</span></el-col>
                                <el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px"><span>To</span></el-col>
                                <el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px"><span>Price</span></el-col>
                            </el-row>
                            <el-row v-for="(t, index) in product.tier" :key="index" style="margin-bottom: 10px;">
                                <el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px">
                                    <el-input v-model="t.from" :disabled="disabled == 0" />
                                </el-col>
                                <el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px">
                                    <el-input v-model="t.to" :disabled="disabled == 0" />
                                </el-col>
                                <el-col :span="6" :md="6" :sm="6" :xs="6" style="margin-right: 8px">
                                    <el-input @keypress.native="numberOnly"  @paste.native="paste($event, index, 'price')" v-model="t.price" :disabled="disabled == 0" />
                                </el-col>
                                <el-col :span="4" :md="4" :sm="4" :xs="4" style="margin-right: 8px" v-if="disabled == 1">
                                    <el-button type="text" @click="deleteTier(index)" style="color: red"><i class="mdi mdi-close" /></el-button>
                                </el-col>
                            </el-row>
                            <el-button :disabled="disabled == 0" size="mini" @click="buttonAddTier" type="primary"><i class="mdi mdi-plus"/> Add Tier</el-button>
                        </el-form-item>
                    </el-col>

                </el-form>
                <div class="clearfix">
                    <el-button v-if="disabled==0" @click="disabled = (disabled + 1) % 2">Edit</el-button>
                    <el-button v-else-if="disabled==1" @click="disabled = (disabled + 1) % 2">Cancel</el-button>
                    <el-button v-if="disabled==1" @click="updatedProduct" type="primary" :loading="loadingBtn">Save</el-button>
                    <el-button @click="$router.back()" style="float: right; margin-bottom: 20px;" class="button">Back</el-button>
                </div>
            </el-card>
		</el-card>
        <el-card class="page-header card-shadow--medium">
            <el-card class="m-10">
                <el-form ref="form" label-width="240px" label-position="left">
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Created At">
                            <el-tag type="success" v-model="product.createdAt" disabled>
                                <template>
                                    {{product.createdAt}}
                                </template>
                            </el-tag>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!hidden" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Name">
                            <el-input v-model="product.productName" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="hidden" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Name" >
                            <template>
                                <el-select @change="handleChangeProductName" v-model="product.productName" disabled placeholder="Select">
                                    <el-option
                                    v-for="item in nameOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item label="Product Type" style="font-weight: bold">
                            <template>
                                <el-select v-model="product.type" placeholder="Select" disabled>
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product SKU">
                            <el-input v-model="product.productSKU" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Alias Name">
                            <el-input v-model="product.aliasName" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Description">
                            <el-input rows="6" v-model="product.description" type="textarea" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Plan">
                            <el-input v-model="product.plan" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!hidden" :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="Product Price">
                            <el-input v-model="product.price" :disabled="disabled == 0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item style="font-weight: bold" label="PPN (%)">
                            <el-row>
                                <el-col :span="20">
                                    <el-input v-model="product.tax" :disabled="disabled == 0"></el-input>
                                </el-col >
                                <el-col :span="4">
                                    <el-button class="ml-10" type="info" size="medium" @click="synchronize('tax')" :disabled="disabled != 0" :loading="loadingSync">
                                        <i class="mdi mdi-sync"></i> Sync
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>
                </el-form>
                <div class="clearfix">
                    <el-button v-if="disabled==0" @click="disabled = (disabled + 1) % 2">Edit</el-button>
                    <el-button v-else-if="disabled==1" @click="disabled = (disabled + 1) % 2">Cancel</el-button>
                    <el-button v-if="disabled==1" @click="updateNewProduct" type="primary" :loading="loadingBtn">Save</el-button>
                    <el-button @click="$router.back()" style="float: right; margin-bottom: 20px;" class="button">Back</el-button>
                </div>
            </el-card>
		</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
import CountryFlag from 'vue-country-flag'
const moment = require('moment')

export default {
	name: 'ProductDetail',
	data () {
		return {
            loadingSync: false,
            discountType:[
				{
				value: 'percentage',
				label: 'Percentage'
				}, {
					value: 'currency',
					label: 'Currency'
				}
			],
            totalCountries: 0,
            countries: [],
            discount: false,
            hidden: false,
            disabled: 0,
            loadingBtn:false,
			total:'',
            product: {type:"", tier: [], whitelistHsm: []},
            nameOptions: [{
				value: 'Whatsapp Conversation',
				label: 'Whatsapp Conversation'
			}, {
				value: 'Whatsapp Notification',
				label: 'Whatsapp Notification'
			},{
				
				value: 'Whatsapp Traffic Outbond',
				label: 'Whatsapp Traffic Outbond'
			},
			 {
				value: 'Shorten URL',
				label: 'Shorten URL'
			}, {
				value: 'Telegram Integration',
				label: 'Telegram Integration'
			}, {
				value: 'Line Integration',
				label: 'Line Integration'
			}],
            options: [{
                value: 'notification',
                label: 'Notification'
            }, {
				value: 'notification_caping',
				label: 'Notification Caping'
			}, {
				value: 'notification_caping_plafon',
				label: 'Notification Caping Plafon'
			}, {
                value: 'subscribe',
                label: 'Subscribe'
            }, {
                value: 'traffic',
                label: 'Traffic'
            }, {
                value: 'traffic_tier',
                label: 'Traffic Tier'
            }, {
				value: 'shorten',
                label: 'Shorten URL'
			}],
            value: '',
            loadingProduct:true,
            dialogConfirm: false,
			dialogTableVisible: false,
            dialogFormVisible: false,
            formLabelWidth: '200px',
            searchTemplate: '',
            hsm: [],
            totalHsm: '',
            loadingTemplate: false
		}
	},
    components: {
        CountryFlag
    },
	methods: {
        synchronize(key= ''){
            let productID = this.$route.params.products
            this.$swal({
              title: 'Are you sure want to sync this product?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, sure!',
              cancelButtonText: 'No',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then(() => {
                this.loadingSync = true
                api({
                    url: config.baseApi+`/consumen/sync-poduct/${productID}`,
                    method: "get",
                    params: {
                        key: key
                    }
                }).then(response => {
                    // alert("success")
                    this.$swal(this.$t('success'), "Product successfully synced", "success")
                    // console.log("sync process success with response ",response)
                    this.loadingSync = false
                }).catch(error => {
                    // alert("error")
                    this.$swal(this.$t('error'), 'Sorry, sync failed. Please try again later.', "error")
                    console.log("sync process error with response ",error)
                    this.loadingSync = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Syncronize canceled'
                });
            });
        },
        totalAfterDisc(type, val, disc = 0){
			if (type == 'percentage') {
				return val - (val * disc / 100)
			}
			else if (type == 'currency') {
				return val - disc
			}
			else {
				return val
			}
		},
        handleChangePrefix(val){
			let found = null
			this.product.prefix = []
			this.discount = false
			if (val.length > 0) {
				val.forEach(el => {
					el = el.replace('+','')
					found = this.countries.find(element => element.prefixCode == el);
					if (found) {
						this.product.prefix.push({
							code_prefix: `+${found.prefixCode}`,
							price : {
								cbp : found.price_cbp,
								bi: found.price_bi,
								ui: found.price_ui
							},
							discount : found.prefixCode == '62' ? {}: false
						})

						if (found.prefixCode == '62') {
							this.discount = true
						}
					}
				})
			}
		},
        handleChangeProductName(value){
            this.options = [{
                value: 'notification',
                label: 'Notification'
            }, {
				value: 'notification_caping',
				label: 'Notification Caping'
			}, {
				value: 'notification_caping_plafon',
				label: 'Notification Caping Plafon'
			}, {
                value: 'subscribe',
                label: 'Subscribe'
            }, {
                value: 'traffic',
                label: 'Traffic'
            }, {
                value: 'traffic_tier',
                label: 'Traffic Tier'
            }, {
				value: 'shorten',
                label: 'Shorten URL'
			}]
			if (value == 'Whatsapp Conversation') {
			this.options.forEach(el => {
					switch (el.value) {
						case "notification":
							el.label += ' (CBP Invoice)'
							break;
						case "notification_caping":
							el.label += ' (CBP Caping)'
							break;
						case "notification_caping_plafon":
							el.label += ' (CBP Hybrid)'
							break;
					}
				})
				// this.product.count = {
				// 	cbp: '',
				// 	ui: '',
				// 	bi: '',
				// 	international: ''
				// }
				this.hidden = true

                if(this.product.allowedPrefix.length > 0){
                    let found = null
                    this.product.allowedPrefix.forEach((el,i) => {
                        el = el.replace('+','')
                        found = this.countries.find(element => element.prefixCode == el);
                        if (found) {
                            if (found.prefixCode == '62') {
                                this.discount = true
                            }
                        }
				    })
                }
			}
            else if (value == 'Maintenance') {
				this.options.push({
					label: 'Chatbot',
					value: 'chatbot'
				})

				// this.products.count = {
				// 	cbp: 0,
				// 	ui: 0,
				// 	bi: 0,
				// 	international: 0
				// }
				this.hidden = true
			}
            else if (value == 'Omnichannel') {
				this.hidden = true
			}
			else {
				this.options.forEach(el => {
					switch (el.value) {
						case "notification":
							el.label = 'Notification'
							break;
						case "notification_caping":
							el.label = 'Notification Caping'
							break;
						case "notification_caping_plafon":
							el.label = 'Notification Caping Plafon'
							break;
					}
				})
				this.product.count = ''
				this.hidden = false
			}
		},
        handleChangeProductType(value){
			// console.log(value)
		},
        async getAllHSM(page = 1){
			this.loadingTemplate = true
			var self = this
			await api({
				url:config.baseApi + 'get_hsm',
				params: {
					page: page,
					search: this.searchTemplate
				},
				method:'GET'
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.hsm = _.remove(response.data.data.list, (v) => { return _.isEmpty(v.message) == false })
					console.log('hsm',this.hsm)
					this.totalHsm = response.data.data.total
				}
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
        numberOnly(e) {
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,46,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
        paste(event, index, field) {
            event.preventDefault()
            var totalCharacterCount = window.event.clipboardData.getData('Text');// || window.clipboardData.getData('Text');
            var strValidChars = "+0123456789";
            var strChar;
            var FilteredChars = "";
            for (var i = 0; i < totalCharacterCount.length; i++) {
                strChar = totalCharacterCount.charAt(i);
                if (strValidChars.indexOf(strChar) != -1) {
                    FilteredChars = FilteredChars + strChar;
                }
            }
			if (field == 'cbp_disc' || field == 'ui_disc' || field == 'bi_disc') {
				this.product.prefix[index].discount[field.replace('_disc','')].value = FilteredChars
			}
			else if(field == 'cbp' || field == 'ui' || field == 'bi'){
                let name = field == 'cbp' ? '': `_${field}`
				this.product[`monthly_free_count${name}`]
			}
			else if(field == 'intern'){
				this.product.monthly_free_count_international = FilteredChars
			}
			else if(field == 'service'){
				this.product.product_service.fee = FilteredChars
			}
			else {
				this.product.tier[index][field] = FilteredChars

			}
        },
        async deleteTier(index){
            await this.product.tier.splice(index, 1)
            if(this.product.tier.length > 1){
                let tierLength = this.product.tier.length
                let beforeLastPosition = tierLength - 2
                let beforeLastTier = this.product.tier[beforeLastPosition]
                let lastPosition = tierLength - 1

                this.product.tier[lastPosition].from = parseInt(beforeLastTier.to) + 1
            }
        },
        async deleteWhitelistHsm(index){
            await this.product.whitelistHsm.splice(index, 1)
            if(this.product.whitelistHsm.length > 1){
                let whitelistHsmLength = this.product.whitelistHsm.length
                let beforeLastPosition = whitelistHsmLength - 2
                let beforeLastTier = this.product.whitelistHsm[beforeLastPosition]
                let lastPosition = whitelistHsmLength - 1

                this.product.whitelistHsm[lastPosition].from = parseInt(beforeLastTier.to) + 1
            }
        },
        buttonAddTier(){
            if(this.product.tier.length > 0){
                let lastPosition = this.product.tier.length - 1
                let lastTier = this.product.tier[lastPosition]
                if(Number.isInteger(parseInt(lastTier.to))){
                    this.product.tier.push({ from: parseInt(lastTier.to) + 1, to: "-", price: parseInt(lastTier.price) + 1000000 })
                } else{
                    this.$message.warning({
                        message: 'Last row of tier is not valid'
                    })
                }
            } else{
                this.product.tier.push({ from: 1, to: "-", price: 1000000 })
            }
        },
        buttonAddWhitelistHsm(){
            if(this.product.whitelistHsm.length > 0){
                let lastPosition = this.product.whitelistHsm.length - 1
                let lastTier = this.product.whitelistHsm[lastPosition]
                if(Number.isInteger(parseInt(lastTier.to))){
                    this.product.whitelistHsm.push(this.product.whitelistHsm)
                } else{
                    this.$message.warning({
                        message: 'Last row of tier is not valid'
                    })
                }
            } else{
                this.product.whitelistHsm.push(this.product.whitelistHsm)
            }
        },
        capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},

        formatPrice(value) {
            return value.toLocaleString('id-ID', { style: 'currency', currency: 'IDR' })
        },

        formatDate(val, format){
            return moment(val).format(format)
        },
        async Prefix(page = 1){
			this.loadingProduct = true
            await api({
                url: config.baseApi + "prefix?page="+page,
                method: 'get'
            })
            .then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				else {
					this.countries = res.data.data.prefix
					this.totalCountries = res.data.data.total
				}
            })
            .catch(err => {

            })
            this.loadingProduct = false
		},
		async detailProducts(){
            this.loadingProduct = true
            let productID = this.$route.params.products
            await api({
                url: config.baseApi + 'product/' + productID,
                method: 'get'
            })
            .then(res => {
                this.product = res.data.data

                if (this.product.type == 'notification') {
                    this.product.monthly_free_count_ui = 'MAX'
                    this.product.monthly_free_count_bi = 'MAX'
                    this.product.monthly_free_count_international = 'MAX'
                }
                
                if (this.product.type == 'notification_caping_plafon') {
                    console.log('Masuk');
                    if (this.product["is_ui_max"]) {
                        this.product.monthly_free_count_ui = 'MAX'
                    }  

                    if (this.product["is_bi_max"]) {
                        this.product.monthly_free_count_bi = 'MAX'
                    } 

                }

                this.handleChangeProductName(this.product.productName)
                this.product.createdAt = moment(this.product.createdAt).format("YYYY-MM-DD HH:mm:ss")
            })
            .catch(err => {

            })
            this.loadingProduct = false
        },
        async updatedProduct(){
            this.loadingBtn = true
            let productID = this.$route.params.products
            let allowedUser = this.product.allowedUser
            allowedUser = '-'

            let data = {
					"allowedUser": this.product.allowedUser,
					"productName": this.product.productName,
					"productSKU": this.product.productSKU,
					"description": this.product.description,
					"createdAt": this.product.createdAt,
					"updatedAt": this.product.updatedAt,
					"type": this.value || this.product.type,
					"plan": this.product.plan,
					"price": this.product.price,
					"minPrice": this.product.minPrice || 0,
					"tax": this.product.tax,
					"count": this.product.count,
                    "aliasName": this.product.aliasName,
                    "monthly_free_count": parseInt(this.product.monthly_free_count) || 0,
                    "max_account": parseInt(this.product.max_account) || 0,
                    tier: this.product.tier,
                    whitelistHsm: this.product.whitelistHsm
				}
            if (this.product.productName == 'Whatsapp Conversation' || this.product.productName == 'Maintenance') {
				if(this.product.prefix.length == 0 && this.product.productName == 'Whatsapp Conversation'){
					this.$message.error({
						showClose: false,
						message: 'All field is required'
					});
					this.loadingBtn = false
					return
				}

                if (this.product.prefix.length > 0) {
                    this.product.prefix.forEach(el => {
                        el.discount.cbp ={type:'',value:Number(el.discount.cbp) || 0}
						el.discount.ui = {type:'',value:Number(el.discount.ui) || 0}
						el.discount.bi = {type:'',value:Number(el.discount.bi) || 0}
                    })
                }

                this.product["monthly_free_count"] = parseInt(this.product.monthly_free_count)|| 0
				this.product["monthly_free_count_ui"] = parseInt(this.product.monthly_free_count_ui) || 0
				this.product["monthly_free_count_bi"] = parseInt(this.product.monthly_free_count_bi) || 0
				this.product["monthly_free_count_international"] = parseInt(this.product.monthly_free_count_international) || 0


                data = {...this.product, ...data}

                if (this.product.monthly_free_count_ui == 'MAX' || this.product.monthly_free_count_ui.toString().trim() == '' || this.product.type == 'notification') {
					data["is_ui_max"] = true
				}
                else {
                    data["is_ui_max"] = false
                }

				if (this.product.monthly_free_count_bi == 'MAX' || this.product.monthly_free_count_bi.toString().trim() == '' || this.product.type == 'notification') {
                    console.log('masuk');
					data["is_bi_max"] = true
				}
                else
                {
                    data["is_bi_max"] = false
                }
			}

			await api({
				url: config.baseApi + 'product/' + productID,
				method: 'patch',
				data: data
			}).then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
					this.dialogFormVisible = false
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success")
					this.dialogFormVisible = false
                    this.detailProducts()
                    this.disabled = 0
                    this.Product()
				}
			}).catch(err => {
                return null
            })
            this.loadingBtn=false
		},
        async updateNewProduct() {
            this.loadingBtn=true;
            let productID = this.$route.params.products;

            let data = {
                "productName": this.product.productName,
                "productSKU": this.product.productSKU,
                "description": this.product.description,
                "createdAt": this.product.createdAt,
                "updatedAt": this.product.updatedAt,
                "type": this.product.type,
                "plan": this.product.plan,
                "price": this.product.price,
                "tax": this.product.tax,
                "aliasName": this.product.aliasName
			}

            await api({
				url: config.baseApi + 'product/' + productID,
				method: 'patch',
				data: data
			}).then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
					this.dialogFormVisible = false
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success")
					this.dialogFormVisible = false
                    this.detailProducts()
                    this.disabled = 0
                    this.Product()
				}
			}).catch(err => {
                return null
            })

            this.loadingBtn=false;
        }
	},
	async mounted(){
        await this.Prefix()
        await this.detailProducts()
        await this.getAllHSM()
	}
}
</script>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-l {
	float:left;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}

.dark {
    background-color: transparent;
    color: #999;
    border: none;
}

table {
    width: 100%;
    border-collapse: collapse;

    th {
        text-align: right;
        padding: 20px;
        padding-bottom: 5px;
        opacity: .7;

        &:first-child {
            text-align: left;
            padding-left: 0px;
            // width: 100%
        }
        &:last-child {
            padding-right: 0px;
        }
    }

    td {
        text-align: right;
        padding: 20px;
        padding-bottom: 5px;
        border-bottom: 1px solid #EEE;

        &:first-child {
            text-align: left;
            padding-left: 0px;
            // width: 100%;
        }
        &:last-child {
            padding-right: 0px;
        }
    }

    tfoot td {
        border: none;
        padding-top: 5px;
    }
}
</style>